import React from 'react';
import { StyleSheet } from 'react-native';
import Animated from 'react-native-reanimated';

import { pointerEventsStyles } from '@garnish/constants';

import { useResponsive } from '../../../../../hooks';
import { type Props } from './NoticeBannersStackWrapper.types';

// ────────────────────────────────────────────────────────────────────────────────

export const NoticeBannersStackWrapper = (props: Props) => {
  const { style, children, containerPointerEvents = 'none', ...restProps } = props;

  const { match } = useResponsive();
  const containerStyles = [
    style,
    match([styles.wrapperXs, undefined]),
    pointerEventsStyles[containerPointerEvents],
  ];

  return (
    <Animated.View style={containerStyles} {...restProps}>
      {children}
    </Animated.View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapperXs: {
    flexDirection: 'column-reverse',
  },
});
